'use strict';

// Keep SVG type at its actual CSS size. Dense charts scroll within their own
// region instead of shrinking labels or overflowing the answer column.
function labelWidth(text, fontSize = 12) {
  return Array.from(String(text)).reduce((width, char) => width + (/^[\x00-\x7f]$/.test(char) ? .62 : 1) * fontSize, 0);
}
function shortenLabel(text, maxWidth) {
  text = String(text);
  if (labelWidth(text) <= maxWidth) return text;
  let value = '';
  for (const char of Array.from(text)) {
    if (labelWidth(value + char + '…') > maxWidth) break;
    value += char;
  }
  return value + '…';
}
function chartLayout(labels, availableWidth = 640, kind = 'bar') {
  const count = Math.max(1, labels.length);
  const containerWidth = Math.max(200, Number.isFinite(availableWidth) ? availableWidth : 640);
  const widest = Math.max(0, ...labels.map(text => labelWidth(text)));
  const basicSpacing = (containerWidth - 76) / Math.max(1, count - (kind === 'line' ? 1 : 0));
  const rotated = widest > basicSpacing - 14 || widest > 110;
  const labelLimit = rotated ? 156 : Math.max(24, Math.min(156, basicSpacing - 14));
  const displayLabels = labels.map(text => shortenLabel(text, labelLimit));
  const displayWidth = Math.max(0, ...displayLabels.map(text => labelWidth(text)));
  const diagonal = rotated ? Math.ceil(displayWidth / Math.SQRT2) : 0;
  const edge = !rotated && kind === 'line' ? displayWidth / 2 + 10 : 0;
  const left = Math.max(54, diagonal + 12, edge), right = Math.max(24, edge);
  const width = Math.max(containerWidth, left + right + count * (rotated ? 36 : 46));
  const plotWidth = width - left - right;
  const spacing = plotWidth / Math.max(1, count - (kind === 'line' ? 1 : 0));
  const positions = labels.map((_, i) => left + (kind === 'line' && count > 1 ? i * spacing : (i + .5) * plotWidth / count));
  const height = rotated ? 226 + diagonal + 16 : 245;
  return { width, height, left, right, plotWidth, positions, displayLabels, rotated, labelY: 220, barWidth: Math.min(62, plotWidth / count * .64), scrollable: width > containerWidth + 1 };
}

module.exports = { chartLayout, labelWidth, shortenLabel };
